import React, { useEffect, useState } from "react";
import styles from "./CompletedOrderPage.module.scss";
import { Button, Menu, MenuItem, Checkbox, ListItemText } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import {
  getAllCompletedOrdersByCartBundle,
  getAllCustomer,
  getAllOrders,
  getAllOrdersByCartBundleId,
  getCartBundleIdOrders,
  getCustomerById,
  getPendingOrdersResponse,
  getProductById,
} from "../../store/actions";
import { GenCustomTable } from "../../components/customComponents/genCustomTable/GenCustomTable";
import SearchInput from "../../components/uiComponents/searchInput/SearchInput";
import {
  getFormatedDateWithMonthText,
  getFormattedDate,
  getObjectFromArrayOfObjects,
} from "../../utils/common/CommonFunctions";

const columns = [
  { id: 1, label: "S.NO", minWidth: 120, align: "center" },
  { id: 2, label: "Cart Bundle ID", minWidth: 170, align: "center" },
  { id: 3, label: "Number of orders", minWidth: 170, align: "center" },
  { id: 4, label: "Customer Name", minWidth: 170, align: "center" },
  { id: 5, label: "Order Created", minWidth: 170, align: "center" },
    { id: 6, label: "Status", minWidth: 170, align: "center" },
];

const statusOptions = [
  { value: 0, label: "Placed" },
  { value: 1, label: "Packed" },
  { value: 2, label: "Shipped" },
  { value: -1, label: "Cancelled" },
];

const CompletedOrderPage = ({
  orders = [],
  customers = [],
  completedcartorder,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    dispatch(getAllCompletedOrdersByCartBundle());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllCustomer());
  }, [dispatch]);
  //   const handleStatusFilter = (data = []) => {
  //     const pendingOrders = data?.filter(
  //       (item) =>
  //         item?.status === 0 ||
  //         item?.status === 1 ||
  //         item?.status === 2 ||
  //         item?.status === -1
  //     );

  //     let filtered = pendingOrders;
  //     if (selectedStatuses.length > 0) {
  //       filtered = filtered.filter((item) =>
  //         selectedStatuses.includes(item?.status)
  //       );
  //     }

  //     if (searchQuery.trim() !== "") {
  //       filtered = filtered.filter((item) => {
  //         const customerName =
  //           getObjectFromArrayOfObjects(customers, "id", item?.customerId)
  //             ?.fullName || "NA";
  //         return customerName.toLowerCase().includes(searchQuery.toLowerCase());
  //       });
  //     }

  //     return filtered;
  //   };

  const handleBtn = (status) => {
    const btnProps = {
      variant: "contained",
      disableRipple: true,
      disableElevation: true,
    };
    console.log("completedcartorder", completedcartorder);

    switch (status) {
      case -1:
        return (
          <Button {...btnProps} className={styles.ovalButton4}>
            Cancelled
          </Button>
        );
      case 0:
        return (
          <Button {...btnProps} className={styles.ovalButton0}>
            Placed
          </Button>
        );
      case 1:
        return (
          <Button {...btnProps} className={styles.ovalButton1}>
            Packed
          </Button>
        );
      case 2:
        return (
          <Button {...btnProps} className={styles.ovalButton2}>
            Shipped
          </Button>
        );
      default:
        return null;
    }
  };

  const handleNavigate = (item = {}) => {
    console.log(item);
    dispatch(
      getCartBundleIdOrders({
        id: item?.cartBundleId,
        callback: {
          success: (data) =>
            navigate("/cartBundleOrders/cartBundleDetails", {
              state: { id: item?.cartBundleId, page: "completed" },
            }),
        },
      })
    );
    // dispatch(getPendingOrdersResponse(item));
    // dispatch(getProductById({ id: item?.productId }));
    // dispatch(getCustomerById({ id: item?.customerId }));
    // setTimeout(() => {
    //   navigate("/orderdetails");
    // }, 100);
  };

  const getStructuredRows = (data = []) => {
    console.log(data);
    return data?.map((item, idx) => ({
      id: item?.id,
      rColumns: [
        idx + 1,
        <Button
          variant="outlined"
          className={styles.ovalButtonOut}
          disableRipple
          disableElevation
          onClick={() => handleNavigate(item)}
        >
          {item?.cartBundleId || "NA"}
        </Button>,
        item?.totalOrders,
        item?.customer,
        getFormattedDate(item?.date),
        <Button className={styles.ovalButton1}>
          Delivered
        </Button>,  
      ],
    }));
  };

  //   console.log("orders", orders);

  const handleFilterClick = (event) => setAnchorEl(event.currentTarget);
  const handleFilterClose = () => setAnchorEl(null);

  const handleToggleStatus = (statusValue) => {
    setSelectedStatuses((prev) =>
      prev.includes(statusValue)
        ? prev.filter((s) => s !== statusValue)
        : [...prev, statusValue]
    );
    // handleFilterClose();
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.topWrapper}>
          <div className={styles.top}></div>
          <div className={styles.search}>
            {/* <SearchInput
              placeholder="Search by customer name"
              onSearch={setSearchQuery}
              minWidth={"300px"}
            />

            <Button
              variant="outlined"
              startIcon={<FilterAltOutlinedIcon />}
              className={styles.filterButton}
              onClick={handleFilterClick}
            >
              Filter
            </Button> */}

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleFilterClose}
            >
              {statusOptions.map((option) => (
                <MenuItem
                  key={option.value}
                  onClick={() => handleToggleStatus(option.value)}
                >
                  <Checkbox
                    checked={selectedStatuses.includes(option.value)}
                    size="small"
                  />
                  <ListItemText primary={option.label} />
                </MenuItem>
              ))}
            </Menu>
          </div>
        </div>

        <div className={styles.bottom}>
          <GenCustomTable
            columns={columns}
            rows={getStructuredRows(
              completedcartorder?.length > 0 ? completedcartorder : []
            )}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  orders: state?.orders?.orders,
  customers: state?.customer?.customers,
  completedcartorder: state?.orders?.completedcartorder,
});

export default connect(mapStateToProps, null)(CompletedOrderPage);
